/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetMyOrganizationsQueryResponse, GetMyOrganizations400, GetMyOrganizations401, GetMyOrganizations403, GetMyOrganizations404, GetMyOrganizations409, GetMyOrganizations500 } from "../../types/organizationController/GetMyOrganizations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getMyOrganizations } from "../../client/organizationController/getMyOrganizations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getMyOrganizationsQueryKey = () => [{ url: '/api/organizations/me' }] as const

export type GetMyOrganizationsQueryKey = ReturnType<typeof getMyOrganizationsQueryKey>

export function getMyOrganizationsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getMyOrganizationsQueryKey()
        return queryOptions<GetMyOrganizationsQueryResponse, ResponseErrorConfig<GetMyOrganizations400 | GetMyOrganizations401 | GetMyOrganizations403 | GetMyOrganizations404 | GetMyOrganizations409 | GetMyOrganizations500>, GetMyOrganizationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getMyOrganizations({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current user organizations
 * {@link /api/organizations/me}
 */
export function useGetMyOrganizations<TData = GetMyOrganizationsQueryResponse, TQueryData = GetMyOrganizationsQueryResponse, TQueryKey extends QueryKey = GetMyOrganizationsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetMyOrganizationsQueryResponse, ResponseErrorConfig<GetMyOrganizations400 | GetMyOrganizations401 | GetMyOrganizations403 | GetMyOrganizations404 | GetMyOrganizations409 | GetMyOrganizations500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getMyOrganizationsQueryKey()
         

         const query = useQuery({
          ...getMyOrganizationsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetMyOrganizations400 | GetMyOrganizations401 | GetMyOrganizations403 | GetMyOrganizations404 | GetMyOrganizations409 | GetMyOrganizations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}